module.exports = __webpack_public_path__ + "img/55889f96-30d2-4032-9340-2d27090394e6.de4f4b7e.webp";